<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      moment,
      title: "Dashboard",
      statData: [
        {
          icon: "bx bx-building-house",
          title: "Companies",
          value: "1,235",
        },
        {
          icon: "bx bx-user",
          title: "Users",
          value: "500",
        },
      ],
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$t("userManagement.list.name"),
          sortable: true,
          tdClass: "w-75",
        },
        // {
        //     key: "email",
        //     label: this.$t("userManagement.list.email"),
        //     sortable: true,
        // },
        // {
        //     key: "phone_number",
        //     label: this.$t("userManagement.list.phoneNumber"),
        //     sortable: true,
        // },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("userManagement.list.action"),
          sortable: false,
        },
      ],
      company_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      user_image: process.env.VUE_APP_MIX_BASE_URL + "images/user.png",
      greet: "",
    };
  },
  computed: mapGetters("companydashboard", [
    "loading",
    "companyData",
    "historyData",
    "followersCount",
  ]),
  methods: {
    ...mapActions("companydashboard", [
      "getList",
      "getHistoryList",
      "getNotificationsList",
    ]),
    getGreetingMsg() {
      return (this.greet = JSON.parse(localStorage.getItem("user")));
    },
    getData() {
      this.getList();
    },
    showFollowers() {
      this.$router.push({ name: "follower.list" });
    },
    getHostory() {
      this.getHistoryList();
    },
    companyimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
    userimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/user.png";
    },
  },
  mounted() {
    this.getGreetingMsg();
    this.getList();
    this.getHistoryList();
    this.getNotificationsList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-6">
        <a href="#" @click="showFollowers()">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">Followers</p>
                  <h4 class="mb-0">
                    {{ followersCount }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <a href="#">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">This Week's Followers</p>
                  <h4 class="mb-0">
                    {{ companyData.this_week_follower }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-3">
        <a href="#">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">Last Week's Followers</p>
                  <h4 class="mb-0">
                    {{ companyData.last_week_follower }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-3">
        <a href="#">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">This Month's Followers</p>
                  <h4 class="mb-0">
                    {{ companyData.this_month_follower }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-3">
        <a href="#">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">Last Month's Followers</p>
                  <h4 class="mb-0">
                    {{ companyData.last_month_follower }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex" style="justify-content: space-between">
              <div class="me-2">
                <h5 class="card-title mb-4">News Feeds</h5>
              </div>
              <div class="me-2">
                <router-link :to="{ name: 'post.add' }" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-plus mr-1"></i>{{ $t("add_post") }}
                </router-link>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col" colspan="2">Post</th>
                    <th scope="col">Likes</th>
                    <th scope="col">Comments</th>
                    <!-- <th scope="col">Action</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(history, index) in historyData" :key="history.id">
                    <td>{{ index + 1 }}</td>
                    <td
                      style="width: 100px"
                      v-if="history.is_company == 0 && history.user"
                    >
                      <img
                        :src="history.user.image_path + '/' + history.user.image"
                        alt=""
                        class="avatar-md h-auto d-block rounded"
                        v-if="history.user.image"
                        style="height: 50px !important"
                        @error="userimageNotFound"
                      />
                      <img
                        :src="user_image"
                        alt=""
                        class="avatar-md h-auto d-block rounded"
                        style="height: 50px !important"
                        v-else
                      />
                    </td>
                    <td style="width: 100px" v-else>
                      <div v-if="history.company">
                        <img
                          :src="history.company.image_path + '/' + history.company.image"
                          alt=""
                          class="avatar-md h-auto d-block rounded"
                          v-if="history.company.image"
                          style="height: 50px !important"
                          @error="companyimageNotFound"
                        />
                        <img
                          :src="company_image"
                          alt=""
                          style="height: 50px !important"
                          class="avatar-md h-auto d-block rounded"
                          v-else
                        />
                      </div>
                    </td>
                    <td v-if="history.is_company == 0 && history.user">
                      <h5 class="font-size-13 text-truncate mb-1">
                        <a
                          class="text-dark"
                          :href="'/company/newsfeeds/show/' + history.id"
                          >{{ history.user.name }}</a
                        >
                      </h5>
                      <p class="text-muted mb-0" v-if="history.created_at">
                        {{ moment(history.created_at).fromNow() }}
                      </p>
                      <p class="text-muted mb-0" v-else>-</p>
                    </td>
                    <td v-else>
                      <div v-if="history.company">
                        <h5 class="font-size-13 text-truncate mb-1">
                          <a
                            class="text-dark"
                            :href="'/company/newsfeeds/show/' + history.id"
                            >{{ history.company.name }}</a
                          >
                        </h5>
                        <p class="text-muted mb-0" v-if="history.created_at">
                          {{ moment(history.created_at).fromNow() }}
                        </p>
                        <p class="text-muted mb-0" v-else>-</p>
                      </div>
                    </td>
                    <td>
                      <i class="bx bx-like align-middle me-1"></i>

                      {{ history.like_users.length + history.like_companies.length }}
                    </td>
                    <td>
                      <i class="bx bx-comment-dots align-middle me-1"></i>
                      {{ history.comments.length }}
                    </td>
                    <!-- <td>
                      <div class="dropdown dropdown">
                        <a
                          aria-haspopup="true"
                          class="text-muted font-size-16"
                          aria-expanded="false"
                          ><i class="mdi mdi-dots-horizontal"></i
                        ></a>
                        <div
                          tabindex="-1"
                          role="menu"
                          direction="right"
                          aria-hidden="true"
                          class="dropdown-menu-end dropdown-menu"
                        >
                          <a class="dropdown-item" href="/dashboard-blog">Action</a
                          ><a class="dropdown-item" href="/dashboard-blog"
                            >Another action</a
                          ><a class="dropdown-item" href="/dashboard-blog"
                            >Something else</a
                          >
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="/dashboard-blog"
                            >Separated link</a
                          >
                        </div>
                      </div>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
